// extracted by mini-css-extract-plugin
export default {"authBackgroundImg":"AuthBackground_authBackgroundImg__pqwQd","smallWarning":"AuthBackground_smallWarning__4+P-+"};